// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u0UD4","select":"styles_select__1A0c7"};